<template>
  <div class="section-container">
    <h2 class="section-title">操作按钮区域</h2>
    <div class="button-group">
      <button @click="handleReset" class="btn btn-reset">重置表单</button>
      <button @click="handleShowHistory" class="btn btn-history">查看历史记录</button>
      <button @click="handleSaveRecord" class="btn btn-save">保存记录</button>
      <button @click="handleGenerateBillImage" class="btn btn-bill-image">生成账单图片</button>
      <button @click="handleCopyText" class="btn btn-copy">复制结算信息</button>
      <button @click="handleExportExcel" class="btn btn-excel">导出Excel</button>
      <button @click="handleExportTXT" class="btn btn-txt">导出TXT</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    hasResult: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleReset() {
      this.$emit('reset');
    },

    handleShowHistory() {
      this.$emit('show-history');
    },

    handleSaveRecord() {
      if (!this.hasResult) {
        alert('暂无计算结果可保存！');
        return;
      }
      this.$emit('save-record');
    },

    handleGenerateBillImage() {
      if (!this.hasResult) {
        alert('暂无计算结果可生成！');
        return;
      }
      this.$emit('generate-bill-image');
    },

    handleCopyText() {
      if (!this.hasResult) {
        alert('暂无计算结果可复制！');
        return;
      }
      this.$emit('copy-text');
    },

    handleExportExcel() {
      if (!this.hasResult) {
        alert('暂无计算结果可导出！');
        return;
      }
      this.$emit('export-excel');
    },

    handleExportTXT() {
      if (!this.hasResult) {
        alert('暂无计算结果可导出！');
        return;
      }
      this.$emit('export-txt');
    }
  }
};
</script>

<style scoped>
.button-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.btn-reset {
  background: #9e9e9e;
  color: #fff;
}

.btn-reset:hover {
  background: #757575;
}

.btn-history {
  background: #9c27b0;
  color: #fff;
}

.btn-history:hover {
  background: #8e24aa;
}

.btn-save {
  background: #42b983;
  color: #fff;
}

.btn-save:hover {
  background: #3aa876;
}

.btn-bill-image {
  background: #e040fb;
  color: #fff;
}

.btn-bill-image:hover {
  background: #c43ede;
}

.btn-copy {
  background: #38b2ac;
  color: #fff;
}

.btn-copy:hover {
  background: #319795;
}

.btn-excel {
  background: #2196f3;
  color: #fff;
}

.btn-excel:hover {
  background: #1976d2;
}

.btn-txt {
  background: #ff9800;
  color: #fff;
}

.btn-txt:hover {
  background: #f57c00;
}

@media (max-width: 750px) {
  .button-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .btn {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    font-size: 13px;
  }
}
</style>
